export const ALERTS = 'alerts';
export const COMMAND_HISTORY = 'commandHistory';
export const DASHBOARD = 'dashboard';
export const DETAILS = 'details';
export const DM1_FAULTS = 'dm1faults';
export const MAINTENANCE = 'maintenance';
export const SUBSCRIPTIONS = 'subscriptions';
export const VALIDATION_ERRORS = 'validationErrors';
export const V2_MAINTENANCE = 'v2_maintenance';

export const ASSET_TABS = [
  ALERTS,
  COMMAND_HISTORY,
  DASHBOARD,
  DETAILS,
  DM1_FAULTS,
  MAINTENANCE,
  SUBSCRIPTIONS,
  VALIDATION_ERRORS,
  V2_MAINTENANCE,
];
